export const documentsRoute: string = "documents";